import React from "react";
import "./App.css";
// import { withAuthenticator } from "@aws-amplify/ui-react";
// import "@aws-amplify/ui-react/styles.css";
import Amplify from "aws-amplify";
import config from "./aws-exports";
import Container from "react-bootstrap/Container";
import ListLDSProperties from "./ListLDSProperties";

Amplify.configure(config);

function App({ signOut, user }) {
  return (
    <div>
      <Container style={{ marginTop: "2%" }}>
        <h1>Search thousands of LDS Church properties in the United States</h1>
        <p>
          A newly released database of public records on nearly 16,000 U.S.
          properties traced to companies owned by The Church of Jesus Christ of
          Latter-day Saints shows at least $15.8 billion in landholdings across
          all 50 states and the District of Columbia — including hundreds of
          multimillion-dollar religious sites, commercial towers, vast farmlands
          and suburban parcels.
        </p>
      </Container>
      <ListLDSProperties />
    </div>
  );
}

export default App;
